import React from 'react';
import styled from 'styled-components';
import SubordinateTable from 'components/table/SubordinateTable';
import { useTranslation } from 'react-i18next';
/**
 * * app > client > android, ios 전체 목록
 */

const ClientVersionTable = ({ tableData, handleModalOpen }) => {
  const { t } = useTranslation();
  const columnsOrigin = [
    {
      title: t(
        'packageIDAppInformation.tabs.appContents.tabPane.clientContens.table.clientVersion',
      ),
      dataIndex: 'client_version',
      width: '10rem',
      render: (text, record) => (
        <TableCellButton onClick={handleModalOpen(record)}>
          {text}
        </TableCellButton>
      ),
    },
    {
      title: t(
        'packageIDAppInformation.tabs.appContents.tabPane.clientContens.table.appStore',
      ),
      dataIndex: 'app_store',
      width: '10rem',
      render: (text, record) => (
        <TableCellButton onClick={handleModalOpen(record)}>
          {text}
        </TableCellButton>
      ),
    },
    {
      title: t(
        'packageIDAppInformation.tabs.appContents.tabPane.clientContens.table.clientStatus',
      ),
      dataIndex: 'client_status',
      width: '10rem',
      render: (text, record, index) => (
        <TableCellButton onClick={handleModalOpen(record)}>
          <StatusText backColor={record.color}>
            {record.client_status_KO}
          </StatusText>
        </TableCellButton>
      ),
    },
  ];
  return <SubordinateTable columns={columnsOrigin} dataSource={tableData} />;
};

export default ClientVersionTable;

const TableCellButton = styled.button`
  width: -webkit-fill-available;
  height: 2rem;
  text-align: left;
  padding-left: 0.8rem;
`;

const StatusText = styled.p`
  background-color: ${(props) => `${props.backColor}`};
  color: #fff;
  font-size: 0.8rem;
  padding: 0.08rem 0.3rem;
  border-radius: 0.2rem;
  display: inline-block;
`;
